module.exports = __webpack_public_path__ + "static/media/icon_map_black.692a6a55.svg";